/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

import {Button, Container, Row, Col} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import businessHelper from "../../helpers/BusinessHelper";

let commonStrings = new LocalizedStrings(common_strings);

class TeacherHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            teacher: props.teacher,
            goBackToClass: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            teacher: nextProps.teacher
        });

        if (nextProps.backToClass) {
            this.setState({
                backToClass: nextProps.backToClass
            });
        }
    }

    render() {
        this.localize();

        if (this.state.goBackToClass === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.props.backToClassId}
            }}/>
        }

        return (
            <>
                <div
                    className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                    style={{
                        minHeight: "600px",
                        backgroundImage:
                            "url(" + businessHelper.backgroundImage("clients") + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center top"
                    }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-8"/>
                    {/* Header container */}
                    <Container className="d-flex align-items-center" fluid>
                        <Row>
                            <Col lg="12" md="10">
                                <h1 className="display-2 text-white">{this.state.teacher ? this.state.teacher.name : ""}</h1>
                                <p className="text-white mt-0 mb-5">
                                    {/*This is your profile page. You can see the progress you've*/}
                                    {/*made with your work and manage your projects or assigned tasks*/}
                                    {(this.state.teacher && this.state.teacher.note) ? this.state.teacher.note : ""}
                                </p>
                            </Col>
                            {this.state.teacher &&
                            <Row style={{alignItems: 'flex-end', marginLeft: 10}}>
                                {this.props.backToClassId ?
                                    (<Button
                                        color="danger"
                                        onClick={(e) => this.backToClass(e)}
                                    >
                                        ⬅️ {this.props.backToClassName}
                                    </Button>) :
                                    (<Button
                                        color="danger"
                                        onClick={e => this.props.backToProfile(e)}
                                    >
                                        ⬅️ {commonStrings.back_to_profile}
                                    </Button>)
                                }
                                {(this.state.teacher.email !== undefined && this.state.teacher.email.length > 0) &&
                                <Button
                                    color="warning"
                                    disabled={this.state.teacher.email === undefined || this.state.teacher.email.length === 0}
                                    onClick={e => this.props.sendEmail(e)}
                                >
                                    {commonStrings.send_message}
                                </Button>
                                }
                                {/*<Button*/}
                                {/*    color="warning"*/}
                                {/*    onClick={e => this.props.showClasses(e)}*/}
                                {/*>*/}
                                {/*    Show classes*/}
                                {/*</Button>*/}
                            </Row>
                            }
                        </Row>
                    </Container>
                </div>
            </>
        );
    }

    backToClass(e) {
        e.preventDefault();
        this.setState({goBackToClass: true})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }
}

export default TeacherHeader;
